import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const INITIAL_STATE = {
  uiState: "idle",
  disbursementId: null,
  batchData: null,
};

const useFileUploadStore = create(
  persist(
    (set) => ({
      ...INITIAL_STATE,

      setUploading: () => set({ uiState: "uploading" }),

      setValidating: (disbursementId) =>
        set({ uiState: "validating", disbursementId, batchData: null }),

      setValidationErrors: ({ paymentChannel, recipientCount, batchId }) =>
        set({
          uiState: "validation-errors",
          batchData: { paymentChannel, recipientCount, batchId },
        }),

      setReadyForApproval: ({ paymentChannel, recipientCount, batchId }) =>
        set({
          uiState: "ready-for-approval",
          batchData: { paymentChannel, recipientCount, batchId },
        }),

      setApproving: () => set({ uiState: "approving" }),

      setFileUploadFailed: () =>
        set({ uiState: "file-upload-failed", batchData: null }),

      resume: (disbursementId, uiState, batchData) =>
        set({ disbursementId, uiState, batchData }),

      resetUpload: () => set({ uiState: "idle" }),

      reset: () => set(INITIAL_STATE),
    }),
    {
      name: "file-upload-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        uiState: state.uiState,
        disbursementId: state.disbursementId,
        batchData: state.batchData,
      }),
    },
  ),
);

export default useFileUploadStore;
